import React from 'react';
import { ForgeTab, ForgeTabBar } from '@tylertech/forge-react';
import { ITabBarChangeEventData } from '@tylertech/forge';
import { I18n } from 'common/i18n';
import { FeatureFlags } from '@socrata/platform/feature-flags';

export const Tabs = ({
  selectedTab,
  onTabChange,
  showMyAlertsTab,
  showWatchlistTab,
}: {
  selectedTab: number;
  onTabChange: (index: number) => void;
  showMyAlertsTab: boolean;
  showWatchlistTab: boolean;
}) => {
  const scope = 'shared.site_chrome.notifications.alert_setting_modal.tab';
  const firstTabName = I18n.t(showMyAlertsTab ? 'notification_and_alerts' : 'notification', { scope });
  const deliveriesTabName = I18n.t(
    FeatureFlags.valueOrDefault('enable_report_scheduled_delivery') ? 'scheduled_deliveries' : 'watchlist',
    { scope },
  );

  return (
    <div className="alert-settings-tabs">
      <ForgeTabBar
        className="nav"
        activeTab={selectedTab}
        clustered
        underline
        on-forge-tab-bar-change={(event: CustomEvent<ITabBarChangeEventData>) =>
          onTabChange(event.detail.index)
        }
      >
        <ForgeTab data-testId={`${firstTabName}-tab`}>{firstTabName}</ForgeTab>
        {showMyAlertsTab && (
          <ForgeTab data-testId={`${I18n.t('my_alerts', { scope })}-tab`}>
            {I18n.t('my_alerts', { scope })}
          </ForgeTab>
        )}
        {showWatchlistTab && (
          <ForgeTab data-testId={`${deliveriesTabName}-tab`}>{deliveriesTabName}</ForgeTab>
        )}
      </ForgeTabBar>
    </div>
  );
};
